import { render, staticRenderFns } from "./list.vue?vue&type=template&id=09b35352&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=09b35352&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b35352",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09b35352')) {
      api.createRecord('09b35352', component.options)
    } else {
      api.reload('09b35352', component.options)
    }
    module.hot.accept("./list.vue?vue&type=template&id=09b35352&scoped=true", function () {
      api.rerender('09b35352', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pattern/list.vue"
export default component.exports